__turbopack_context__.v({
  "button": "L_hdCG_button",
  "container": "L_hdCG_container",
  "controlButton": "L_hdCG_controlButton",
  "deleteButton": "L_hdCG_deleteButton",
  "more": "L_hdCG_more",
  "moreIcon": "L_hdCG_moreIcon",
  "name": "L_hdCG_name",
  "pencilIcon": "L_hdCG_pencilIcon",
  "positionTitle": "L_hdCG_positionTitle",
  "positionsList": "L_hdCG_positionsList",
  "trashIcon": "L_hdCG_trashIcon",
});
